const channels = [
  {
    tag: "即时沟通",
    icon: "ri-wechat-line",
    name: "微信 / 企微投稿",
    color: "text-accent-600 bg-accent-100",
    desc: "适合需要边聊边核实的短线索，编辑回复快、可及时补充细节，是当前受理速度最快的一类入口。",
    badge: ["时效最快", "支持语音"],
    dot: "推荐新线索走这里",
  },
  {
    tag: "长文首选",
    icon: "ri-mail-send-line",
    name: "邮箱投稿",
    color: "text-primary-600 bg-primary-100",
    desc: "内容较长、附件较多的稿件建议走邮箱。便于整理归档，可在正文一次性写清时间线与关键人物。",
    badge: ["支持多附件", "可归档"],
    dot: "长文与证据包走这里",
  },
  {
    tag: "在线直达",
    icon: "ri-link-m",
    name: "网页在线表单",
    color: "text-secondary-700 bg-secondary-100",
    desc: "通过网页链接提交，无需来回加好友，字段清晰。适合有完整材料的投稿人快速一键上传。",
    badge: ["无需添加好友", "一步提交"],
    dot: "材料齐全时最快",
  },
  {
    tag: "社群渠道",
    icon: "ri-team-line",
    name: "私信 / 社群 / 后台留言",
    color: "text-primary-700 bg-primary-100",
    desc: "作为辅助入口，可在评论区或社群留言被编辑注意到，适合线索先行、材料后补的灵活场景。",
    badge: ["灵活补充", "辅助入口"],
    dot: "线索先行后补材料",
  },
];

export default function Methods() {
  return (
    <section id="methods" className="scroll-mt-24 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-700">
              <i className="ri-discuss-line" aria-hidden="true"></i>
              投稿方式
            </span>
            <h2 className="mt-4 text-2xl font-bold text-foreground-950 md:text-4xl">
              当前开放的四大投稿入口
            </h2>
            <p className="mt-3 text-base leading-relaxed text-foreground-600">
              不同入口的受理范围与时效不同，先看类型、再选通道，能明显减少被退回或石沉大海的概率。
            </p>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {channels.map((c, i) => (
            <article
              key={c.name}
              className="group relative flex flex-col rounded-2xl border border-background-200/70 bg-background-50 p-6 transition-all duration-300 hover:-translate-y-1.5 hover:border-primary-200 hover:bg-background-100/60"
            >
              <span className="absolute right-5 top-5 font-heading text-4xl font-extrabold text-background-200 transition-colors group-hover:text-primary-100">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className={`inline-flex h-12 w-12 items-center justify-center rounded-xl ${c.color}`}>
                <i className={`${c.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <span className="mt-4 text-xs font-semibold text-foreground-500">{c.tag}</span>
              <h3 className="mt-1 text-lg font-bold text-foreground-950">{c.name}</h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
              <div className="mt-4 flex flex-wrap gap-2">
                {c.badge.map((b) => (
                  <span
                    key={b}
                    className="whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-1 text-xs font-medium text-secondary-800"
                  >
                    {b}
                  </span>
                ))}
              </div>
              <div className="mt-4 flex items-center gap-2 border-t border-background-200/70 pt-4 text-xs font-medium text-primary-600">
                <i className="ri-flashlight-line" aria-hidden="true"></i>
                {c.dot}
              </div>
            </article>
          ))}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-4 rounded-2xl border border-accent-200 bg-accent-100/70 px-6 py-5 sm:flex-row">
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-accent-500 text-background-50">
              <i className="ri-lightbulb-flash-line text-lg" aria-hidden="true"></i>
            </span>
            <p className="text-sm text-accent-900">
              拿不准走哪个入口？别硬猜——<strong>短线索找微信、长文找邮箱</strong>，几乎不会错。
            </p>
          </div>
          <a
            href="#flow"
            className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
          >
            看完整投稿流程
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </a>
        </div>
      </div>
    </section>
  );
}